// @ts-nocheck

import { ChevronsUpDown } from "lucide-react";
import React, { ReactNode } from "react";

import { IgTypography } from "@intelligems/ig-theme/IgTypography";
import { Autocomplete, AutocompleteProps, Box } from "@mui/material";
import { ChipTypeMap } from "@mui/material/Chip";
import { ListboxComponent } from "@src/components/VirtualAutoComplete/List";
import { StyledPopper } from "@src/components/VirtualAutoComplete/StyledPopper";

export const VirtualAutoComplete = <
  Value,
  Multiple extends boolean | undefined,
  DisableClearable extends boolean | undefined,
  FreeSolo extends boolean | undefined,
  ChipComponent extends React.ElementType = ChipTypeMap["defaultComponent"],
>(
  props: Omit<
    AutocompleteProps<any, any, any, any, ChipComponent>,
    "renderOption" | "renderGroup"
  > & { formatter: (data: Value) => ReactNode; label?: string }
) => {
  const { formatter, slotProps, slots, ...rest } = props;
  return (
    <Box>
      {props.label ? (
        <span>
          <IgTypography>{props.label}</IgTypography>
        </span>
      ) : null}
      <Autocomplete
        {...rest}
        disableListWrap
        renderOption={(props, option, state) =>
          [props, formatter(option), state.index] as any
        }
        popupIcon={<ChevronsUpDown size={16} />}
        renderGroup={(params) => params as any}
        slots={{
          popper: StyledPopper,
          ...slots,
        }}
        slotProps={{
          listbox: {
            component: ListboxComponent,
          },
          ...slotProps,
        }}
      />
    </Box>
  );
};
